// import { Container } from "../../atoms/container/Container";
import { RadioButton } from "../../atoms/singleRadioButton/RadioButton";
import style from "./addressCard.module.scss";
import { Address } from "../address/Address";
import { useGetHospitalDist } from "../../../hooks/useGetHospitalDistance/useGetHospitalDist";

interface AddressCardProps {
  address: any;
  handleAddressSelection: any;
  selectedAddress: any;
  leftSideIcon: string;
  rightSideBadgeText: string[];
  pickupLocation?: any
  count?: any
  handleEmergency?: string[]
}
export const AddressCard: React.FC<AddressCardProps> = ({
  count,
  address,
  handleAddressSelection,
  selectedAddress,
  leftSideIcon,
  rightSideBadgeText,
  pickupLocation,
  handleEmergency
}) => {
  // console.log('address:', address)
  // console.log('pickupLocation:', pickupLocation);
  const { km } = useGetHospitalDist({ pickupLocation, address, count })
  const hasCoordinates = address?.geoLocation?.coordinates?.length > 0 || address?.location?.coordinates?.length > 0 || (address?.location?.latitude && address?.location?.longitude);


  return (
    <>
      <div style={{ width: "100%" }}>
        <div className={style.card_flex}>
          <div className={style.radio_btn}>
            <RadioButton
              id={address?._id}
              name="addressSelection"
              isSelected={address === selectedAddress}
              onChange={() => handleAddressSelection(address)}
              className={style.radio}
            />
          </div>
          <Address
            onChange={() => handleAddressSelection(address)}
            leftSideIcon={leftSideIcon}
            rightSideBadgeText={handleEmergency?.length ? [...handleEmergency,...rightSideBadgeText] : rightSideBadgeText}
            className={
              address === selectedAddress ? style.card_border : style.card
            }
            line1={address?.label || address?.name || ""}
            line2={address?.address || [address?.addressLine1, address?.addressLine2, address?.city, address?.state, address?.pinCode].filter(Boolean).join(", ")}
            // line3={rightSideBadgeText[0] !== "Partnered" ? `${address?.addressLine2 || ""}, ${address?.city || ""}` : ""}
            line4={hasCoordinates && km != null ? `kilometers:${km}` : undefined}
          />
        </div>
      </div>
    </>
  );
};
